import React from "react";
import { PrivacyPolicyPage } from "../Components/account/PrivacyPolicyPage";
import CommonAppShell from "../Components/CommonAppShell";

function PrivacyPolicy(): JSX.Element {
  return (
    <CommonAppShell sidebarLabel="privacyPolicy" style={{ background: "#f2f4fa" }} padding="md" isSidebar={true}>
      <PrivacyPolicyPage />
    </CommonAppShell>
  );
}

export { PrivacyPolicy };
